import { useIsFetching } from "@tanstack/react-query";
import { onMessage } from "firebase/messaging";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./authentication/auth.css";
import Enterotp from "./authentication/Enterotp";
import Forget from "./authentication/Forget";
import Login from "./authentication/Login";
import Resetpassword from "./authentication/Resetpassword";
import Loader from "./components/Loader/Loader";
import {
  getMessagingInstance,
  getOrCreateFcmToken,
} from "./firebase/firebaseConfig";
import CreateLabelPublic from "./pages/LabelManagement/CreateLabelPublic";
import LegalDocument from "./pages/legal/LegalDocument";
import DeleteAccount from "./pages/deleteAccount/DeleteAccount";
import PanelRoutes from "./routes/PanelRoutes";
import { PublicAuth, UserAuth } from "./utils/ProtectedRoute";
import ScrollTop from "./utils/ScrollTop";

function App() {
  const isFetching = useIsFetching(); 
  async function requestPermission() {
    try {
      if (
        typeof window === "undefined" ||
        !("Notification" in window) ||
        !("serviceWorker" in navigator)
      ) {
        console.log("Notifications are not supported in this browser/webview environment.");
        return;
      }

      const messaging = await getMessagingInstance();
      if (!messaging) {
        console.log("Firebase Messaging is not supported in this browser/webview environment.");
        return;
      }

      const token = await getOrCreateFcmToken();
      if (token) {
        onMessage(messaging, (payload) => {
          const { title, body } = payload?.notification || payload?.data || {};
          if (title && "Notification" in window && Notification.permission === "granted") {
            new Notification(title, {
              body,
            });
          }
        });
      }
    } catch (error) {
      console.error("Error setting up push notifications:", error);
    }
  }

  useEffect(() => {
    requestPermission();
  }, []);

  return (
    <>
      <ScrollTop />
      <Routes>
        <Route path="/public-create-label" element={<CreateLabelPublic/>} />
        <Route path="/privacy-policy" element={<LegalDocument />} />
        <Route path="/service-agreement" element={<LegalDocument />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        {/* <Route path="*" element={<NotFound />} /> */}

        {/*********************Admin Routes*********************/}
        <Route path="*" element={<UserAuth />}>
          <Route path="*" element={<PanelRoutes />} />
        </Route>

        {/*********************All Public Routes*********************/}
        <Route path="*" element={<PublicAuth />}>
          <Route path="" element={<Login />} />
          <Route path="forget" element={<Forget />} />
          <Route path="otp" element={<Enterotp />} />
          <Route path="reset-password/:id" element={<Resetpassword />} />
        </Route>
      </Routes>
      {!!isFetching && <Loader />}
    </>
  );
}

export default App;
